import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const userOrdersService = createApi({
  reducerPath: "userOrdersService",
  tagTypes: ["UserOrders"],
  baseQuery: fetchBaseQuery({
    baseUrl: "/api/",
    prepareHeaders: (headers, { getState }) => {
      const token = getState()?.authReducer?.userToken;

      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }

      headers.set("accept", "application/json");

      return headers;
    },
  }),
  endpoints: (builder) => ({
    getOrders: builder.query({
      query: (page = 1) => `user/orders?page=${page}`,
      providesTags: ["UserOrders"],
    }),

    getOrderDetails: builder.query({
      query: (id) => `user/orders/${id}`,
      providesTags: ["UserOrders"],
    }),

    getReturnRequests: builder.query({
      query: (page = 1) => `user/return-requests?page=${page}`,
      providesTags: ["UserOrders"],
    }),

    submitReturnRequest: builder.mutation({
      query: ({ id, formData }) => ({
        url: `user/orders/${id}/return-requests`,
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["UserOrders"],
    }),

    createSupportMessage: builder.mutation({
      query: (data) => ({
        url: "user/contact-messages",
        method: "POST",
        body: data,
      }),
    }),
  }),
});

export const {
  useGetOrdersQuery,
  useGetOrderDetailsQuery,
  useGetReturnRequestsQuery,
  useSubmitReturnRequestMutation,
  useCreateSupportMessageMutation
} = userOrdersService;

export default userOrdersService;
